"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCancellableRequest = exports.handleCancellableResponse = void 0;
var axios_1 = require("axios");
var currentExecutingCancellableRequests = {};
var handleCancellableResponse = function (token) {
    if (!token) {
        return;
    }
    var key = Object.keys(currentExecutingCancellableRequests).find(function (key) { return currentExecutingCancellableRequests[key].token === token; });
    if (key) {
        delete currentExecutingCancellableRequests[key];
    }
};
exports.handleCancellableResponse = handleCancellableResponse;
var handleCancellableRequest = function (request) {
    var cancelUniqId = request.cancelToken;
    if (currentExecutingCancellableRequests[cancelUniqId]) {
        var source = currentExecutingCancellableRequests[cancelUniqId];
        delete currentExecutingCancellableRequests[cancelUniqId];
        source.cancel("canceled");
    }
    if (cancelUniqId) {
        var CancelToken_1 = axios_1.default.CancelToken;
        var source = CancelToken_1.source();
        request.cancelToken = source.token;
        currentExecutingCancellableRequests[cancelUniqId] = source;
    }
};
exports.handleCancellableRequest = handleCancellableRequest;
